<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="p-3 card">
                <h3>{{ "ProsecutionDecision" | translate }}</h3>
                <div class="col-5 mb-2">
                  
                  <button class="btn btn-primary"*ngIf="(caseDetials.stageId==100 || caseDetials.stageId==101) && caseservice.case && caseservice.case.sendToProsBySystem==false &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId))" (click)="AddProsecution(AddProsecutionResponseModal);" href="javascript:void(0);">
                      <i class="fa fa-plus-circle"></i>
                      <span> {{'AddProsecutionDecision' | translate}} </span>
                  </button>

                </div>
                <table class="table table-striped mt-3">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ "DecisionNumber" | translate }}</th>
                        <th>{{ "TypeOfJudge" | translate }}</th>
                        <th>{{ "IsTherePenalty" | translate }}</th>
                        <th>{{ "Remarks" | translate }}</th>
                        <th>{{ "CourtId" | translate }}</th>
                        <th>{{ "CourtName" | translate }}</th>
                        <th>{{ "JudgeId" | translate }}</th>
                        <th>{{ "JudgeName" | translate }}</th>
                        <th>{{ "OrderDateHJ" | translate }}</th>
                        <th>{{ "Attachments" | translate }}</th>
                        <th>{{ "Preview" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let prosecutionDecision of prosecutionDecisionsArr">
                        <td>{{ prosecutionDecision.decisionnumber }}</td>

                        <td *ngIf="prosecutionDecision.isfinal">{{ "Final" | translate }}</td>
                        <td *ngIf="!prosecutionDecision.isfinal">{{ "Primary" | translate }}</td>

                        <td *ngIf="!prosecutionDecision.haspunishment">{{ "Punished" | translate }}</td>
                        <td *ngIf="prosecutionDecision.haspunishment">{{ "Innocence" | translate }}</td>

                        <td>{{ prosecutionDecision.remarks }}</td>
                        <td>{{ prosecutionDecision.courtid ? prosecutionDecision.courtid : '-' }}</td>
                        <td>{{ prosecutionDecision.court ? prosecutionDecision.court : '-'}}</td>
                        <td>{{ prosecutionDecision.judgeid ? prosecutionDecision.judgeid : '-' }}</td>
                        <td>{{ prosecutionDecision.judgename ? prosecutionDecision.judgename : '-' }}</td>
                        <td>{{ prosecutionDecision.orderdatehj | toDateOnly }}</td>
                        <td>
                          <a (click)="AddAttachmentModal(AddAttachment,prosecutionDecision.prosecutionDecsionId,!((caseDetials.stageId==100 || caseDetials.stageId==101) && prosecutionDecision.isManual && caseDetials && caseDetials.sendToProsBySystem==false &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId) )) );"><i class="fa fa-files-o"></i></a>
                        </td>
                        <td>
                          <a (click)="previewProsecutionDecision(prosecutionDecision.prosecutionDecsionId, previewProsecutionDecisionModal)">
                            <i class="fa fa-eye"></i>
                          </a>
                          &nbsp;
                          &nbsp;
                          &nbsp;
                          <a 
                             *ngIf="(caseDetials.stageId==100 || caseDetials.stageId==101) && prosecutionDecision.isManual && caseDetials && caseDetials.sendToProsBySystem==false &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId))" 
                             (click)="deleteProsecution(confirmDelete,prosecutionDecision.prosecutionDecsionId)">
                              <i class="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                
            </div>
        </div>
    </div>
</div>

<ng-template #previewProsecutionDecisionModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
      <div></div>
      <h4 class="modal-title" id="modal-basic-title">
        {{ "PreviewProsecutionDecision" | translate }}
      </h4>
  
      <i
        style="font-size: 20px"
        class="fa fa-close"
        (click)="modal.dismiss('Cross click')"
      ></i>
    </div>
    <div class="modal-body">
      <div class="custom-form">
        <div class="col-12 offset-1">
          <div class="card p-3">
            <div class="form-group row">
              <div class="col-lg-12">
                <label>{{ "TypeOfJudge" | translate }}</label>
                <span *ngIf="previewObj.isfinal" class="form-control" readonly>{{ "Final" | translate }}&nbsp;</span>
                <span *ngIf="!previewObj.isfinal" class="form-control" readonly>{{ "Primary" | translate }}&nbsp;</span>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <label> {{ "IsTherePenalty" | translate }} </label>
                <span *ngIf="previewObj.haspunishment" class="form-control" readonly>{{ "Punished" | translate }}&nbsp;</span>
                <span *ngIf="!previewObj.haspunishment" class="form-control" readonly>{{ "Innocence" | translate }}&nbsp;</span>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-12">
                <label>{{ "Remarks" | translate }}</label>
                <span class="form-control" readonly>{{previewObj.remarks}}&nbsp;</span>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-6">
                <label> {{'CourtId'|translate}}</label>
                <span class="form-control" readonly>{{previewObj.courtid}}&nbsp;</span>
              </div>
              <div class="col-lg-6">
                <label>{{'CourtName'|translate}} </label>
                <span class="form-control" readonly>{{previewObj.court}}&nbsp;</span>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-6">
                <label>{{ "JudgeId" | translate }}</label>
                <span class="form-control" readonly>{{previewObj.judgeid}}&nbsp;</span>
              </div>
              <div class="col-lg-6">
                <label>{{ "JudgeName" | translate }}</label>
                <span class="form-control" readonly>{{previewObj.judgename}}&nbsp;</span>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-6">
                <label>{{ "DecisionNumber" | translate }}</label>
                <span class="form-control" readonly>{{previewObj.decisionnumber}}&nbsp;</span>
              </div>
              <div class="col-lg-6">
                <label>{{ "OrderDateHJ" | translate }}</label>
                <span class="form-control" readonly>{{previewObj.orderdatehj | toDateOnly}}&nbsp;</span>
              </div>
            </div>
            <h4 class="mt-3">{{ "Attachments" | translate }}</h4>
            <hr>
            <app-general-attachment [ElementTypeId]="'10'" [loadDataFP]="loadfromparent2"></app-general-attachment>

          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-footer row"
      style="justify-content: flex-end; padding: 1rem 2rem"
    >
      <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
        {{ "Close" | translate }}
      </button>
    </div>
</ng-template>

<ng-template #AddProsecutionResponseModal let-modal>
  <div class="modal-header" style="justify-content: space-between">
    <div></div>
    <h4 class="modal-title" id="modal-basic-title">
        {{ "AddProsecutionDecision" | translate }}
    </h4>
    <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
  </div>
  <div class="modal-body">
      <div class="custom-form">
          <div class="col-12 offset-1">
              <div class="card p-3">
                  <div class="form-group row">
                      <div class="col-lg-6 row">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                          <label>{{ "TypeOfJudge" | translate }}</label>
                          <span *ngIf="isFinal==undefined" class="alert requriedfield">*</span>
                        </div>
                        <div class="col-lg-6">
                          <div class="custom-control custom-checkbox" style="display: flex; align-items: center" >
                            <input [checked]="isFinal == true" (change)="chaneIsFinal(true)" type="radio" name="isFinal" />
                            <label style="margin-top: 4px">
                              <span>{{ "Final" | translate }}</span>
                            </label>
                          </div>
                        </div>
                        <div class="col-lg-6"> 
                          <div class="custom-control custom-checkbox" style="display: flex; align-items: center" >
                            <input [checked]="isFinal == false" (change)="chaneIsFinal(false)" type="radio" name="isFinal" />
                            <label style="margin-top: 4px">
                              <span>{{ "Primary" | translate }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 row">
                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                          <label> {{ "IsTherePenalty" | translate }} </label>
                          <span *ngIf="hasPunishment==undefined" class="alert requriedfield">*</span>
                        </div>
                        <div class="col-lg-6">
                          <div class="custom-control custom-checkbox" style="display: flex; align-items: center" >
                            <input [checked]="hasPunishment == true" (change)="chaneHasPunishment(true)" type="radio" name="hasPunishment" />
                            <label style="margin-top: 4px">
                              <span>{{ "Punished" | translate }}</span>
                            </label>
                          </div>
                        </div>
                        <div class="col-lg-6"> 
                          <div class="custom-control custom-checkbox" style="display: flex; align-items: center" >
                            <input [checked]="hasPunishment == false" (change)="chaneHasPunishment(false)" type="radio" name="hasPunishment" />
                            <label style="margin-top: 4px">
                              <span>{{ "Innocence" | translate }}</span>
                            </label>
                          </div>
                        </div>
                          
                      </div>
                  </div>
                  <div class="form-group row mt-3">
                    <div class="col-lg-12">
                      <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label>{{ "Remarks" | translate }}</label>
                        <span *ngIf="Remarks.invalid" class="alert requriedfield">*</span>
                      </div>
                      <textarea id="remarks" required #Remarks="ngModel" class="form-control" rows="2" [(ngModel)]="remarks" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Remarks' | translate }}"></textarea>
                    </div>
                  </div>
                  <div class="formg-group row mt-3">
                    <div class="col-lg-6">
                      <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label> {{'DecisionNumber' | translate }}</label>
                        <span *ngIf="DecisionNumber.invalid" class="alert requriedfield">*</span>
                      </div>
                      <input id="decisionNumber" required #DecisionNumber="ngModel" type="text" class="form-control" [(ngModel)]="decisionNumber" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'DecisionNumber' | translate }}"/>

                    </div>
                    <div class="col-lg-6">
                      <label> {{'OrderDateHJ'|translate}}</label>
                      <datepicker [(maxHijri)]="currentDate" [(maxGreg)]="currentDate" (selectedDateChange)="SelectedDateChangeExcel($event)" [selectedDateType]="1"></datepicker>
                    </div>
                  </div>
                  <div class="form-group row mt-3">
                    <div class="col-lg-6">
                      <label> {{'CourtName'|translate}}</label>
                      <input id="court" type="text" class="form-control" [(ngModel)]="court" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'CourtName' | translate }}"/>
                    </div>
                    <div class="col-lg-6">
                      <label>{{ "CourtId" | translate }}</label>
                      <input id="courtId" (keypress)="numberOnly($event)" type="text" class="form-control" [(ngModel)]="courtId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'CourtId' | translate }}"/>
                    </div>
                  </div>
                  <div class="form-group row mt-3">
                    <div class="col-lg-6">
                      <label> {{'JudgeName'|translate}}</label>
                      <input id="judge" type="text" class="form-control" [(ngModel)]="judgeName" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'JudgeName' | translate }}"/>
                    </div>
                    <div class="col-lg-6">
                      <label>{{ "JudgeId" | translate }}</label>
                      <input id="JudgeId" (keypress)="numberOnly($event)" type="text" class="form-control" [(ngModel)]="judgeId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'JudgeId' | translate }}"/>
                    </div>
                  </div>
                  <div class="row m-2 col-12">
                      <div class="col-4"></div>
                      <div class="col-4">
                          <button [disabled]="isFinal==undefined || hasPunishment==undefined || Remarks.invalid || DecisionNumber.invalid" *ngIf="isInsert" type="button" class="btn btn-primary" (click)="onCreateRecord()">
                              {{ "Save" | translate }}
                          </button>

                      </div>
                  </div>
                  <h4 class="mt-3" *ngIf="ProsecutionDecsionId">{{ "Attachments" | translate }}</h4>
                  <hr>
                  <app-general-attachment [ElementTypeId]="'10'" [loadDataFP]="loadfromparent" *ngIf="ProsecutionDecsionId!=null"></app-general-attachment>

              </div>
          </div>
      </div>
  </div>
  <div class="modal-footer row"
       style="justify-content: flex-end; padding: 1rem 2rem">
      <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
          {{ "Close" | translate }}
      </button>
  </div>
</ng-template>



<ng-template #AddAttachment let-modal>
  <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
          {{'Attachments'|translate}}
      </h4>
  </div>
  <div class="modal-body text-center">
      <app-general-attachment [ElementTypeId]="'10'" [loadDataFP]="loadfromparent"></app-general-attachment>

  </div>
  <div class="modal-footer">

      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
          {{ "Close" | translate }}
      </button>
  </div>
</ng-template>





<ng-template #confirmDelete let-modal>
  <div class="modal-header" style="justify-content: center">
      <h5 class="modal-title text-danger" id="modal-basic-title">
          <b>
              <app-feather-icons [icon]="'alert-triangle'" style="position:relative; top:4px;"></app-feather-icons> {{
              "ConfirmDeleteOperation" | translate
              }}
          </b>
      </h5>
  </div>
  <div class="modal-body text-center">
      <p class="alert fs-6">{{ "SelectedRecordwillbeDeleted" | translate }}</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="onDelete(modal)">
          {{ "Yes" | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
          {{ "No" | translate }}
      </button>
  </div>
</ng-template>
